export default __webpack_public_path__ + "static/media/alert-sign.cd9d5eb1.svg";